import {
	Button,
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownSection,
	DropdownTrigger,
	Tab,
	Tabs,
} from "@heroui/react";
import { Icon } from "@iconify/react";
import { TRequest } from "@shared/entities";
import { useEffect, useMemo, useState } from "react";
import { useAppApi } from "src/appApi";
import { RequestsTable } from "src/widgets/RequestsTable/RequestsTable";

export const columns: any[] = [
	{
		key: "phone",
		label: "תעודת זהות",
	},
	{
		key: "first_name",
		label: "שם פרטי",
	},
	{
		key: "last_name",
		label: "שם משפחה",
	},
	{
		key: "actions",
		label: "פעולות",
	},
];

export default function BrokerPage() {
	const appApi = useAppApi();

	const [requests, setRequests] = useState<TRequest[]>([]);

	const [selectedTab, setSelectedTab] = useState<string | number>("active");
	const [selectedMonth, setSelectedMonth] = useState<string | null>(null);

	const handleMonthSelect = (key: string) => {
		setSelectedMonth(key === "all" ? null : key);
	};

	const availableMonths = [
		{ value: "0", label: "January" },
		{ value: "1", label: "February" },
		{ value: "2", label: "March" },
		{ value: "3", label: "April" },
		{ value: "4", label: "May" },
		{ value: "5", label: "June" },
		{ value: "6", label: "July" },
		{ value: "7", label: "August" },
		{ value: "8", label: "September" },
		{ value: "9", label: "October" },
		{ value: "10", label: "November" },
		{ value: "11", label: "December" },
	] as const;

	useEffect(() => {
		appApi.api.broker.getRequests().then(setRequests);
	}, []);

	const filteredRequests = useMemo(() => {
		let filtered = requests;

		// Filter by month if selected
		if (selectedMonth) {
			filtered = filtered.filter((request) => {
				const orderDate = new Date(request.createdAt);
				const orderMonth = orderDate.getMonth();
				const orderMonthStr = orderMonth.toString();
				return orderMonthStr === selectedMonth;
			});
		}

		// Filter by status tab
		if (selectedTab === "active") {
			filtered = filtered.filter(
				(order) =>
					order.status === "pending" ||
					order.status === "pending_doctor" ||
					order.status === "change_required_broker"
			);
		} else if (selectedTab === "completed") {
			filtered = filtered.filter((order) => order.status === "completed");
		} else if (selectedTab === "rejected") {
			filtered = filtered.filter((order) => order.status === "rejected");
		}

		return filtered;
	}, [requests, selectedMonth, selectedTab]);

	return (
		<main className="min-h-screen w-full">
			<div className="container mx-auto flex flex-col px-4 pt-8">
				<div className="self-center">
					<h1 className="justify-items-center text-3xl font-bold">הפניות שלך</h1>
				</div>
				<div className="flex gap-6 items-center my-4 justify-between">
					<Button
						color="primary"
						startContent={<Icon icon="lucide:plus" width={18} />}
						onPress={() => appApi.navigate("/broker/create-request")}
					>
						צור פנייה חדשה
					</Button>
					<Tabs
						aria-label="Order status tabs"
						selectedKey={selectedTab}
						onSelectionChange={setSelectedTab}
						className="px-4"
					>
						<Tab key="all" title="כל הפניות" />
						<Tab key="active" title="פניות בטיפול" />
						<Tab key="completed" title="פניות שהסתיימו" />
						<Tab key="rejected" title="פניות שנדחו" />
					</Tabs>
					<Dropdown>
						<DropdownTrigger>
							<Button variant="flat" endContent={<Icon icon="lucide:chevron-down" />}>
								{selectedMonth !== null
									? availableMonths.find((m: any) => m.value === selectedMonth)?.label
									: "לפי חודש"}
							</Button>
						</DropdownTrigger>
						<DropdownMenu
							aria-label="Filter by month"
							onAction={(key) => handleMonthSelect(key.toString())}
						>
							<DropdownItem key="all">All Months</DropdownItem>
							<DropdownSection>
								{availableMonths.map((month) => (
									<DropdownItem key={month.value}>{month.label}</DropdownItem>
								))}
							</DropdownSection>
						</DropdownMenu>
					</Dropdown>
				</div>
				<RequestsTable onSave={() => {}} requests={filteredRequests} doctors={[]} />
			</div>
		</main>
	);
}
